import React from 'react';

/**
 * Comparison Table Component
 *
 * A two-column table for showing myth vs reality comparisons.
 * Used in the Neuromyths section.
 */
const ComparisonTable = ({
  rows = [],
  mythHeader = 'Myth',
  realityHeader = 'The Science Says',
  showSources = true
}) => {
  if (!rows || rows.length === 0) {
    return null;
  }

  return (
    <div className="comparison-table-wrapper">
      <table className="comparison-table" role="table" aria-label="Common neuromyths compared to scientific reality">
        <thead>
          <tr>
            <th scope="col">{mythHeader}</th>
            <th scope="col">{realityHeader}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td className="comparison-table__myth-cell">
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <span className="comparison-table__icon comparison-table__icon--myth" aria-hidden="true">
                    ✗
                  </span>
                  <span className="comparison-table__text">{row.myth}</span>
                </div>
              </td>
              <td className="comparison-table__reality-cell">
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <span className="comparison-table__icon comparison-table__icon--reality" aria-hidden="true">
                    ✓
                  </span>
                  <div>
                    <span className="comparison-table__text">{row.reality}</span>
                    {showSources && row.source && (
                      <span className="comparison-table__source">
                        Source: {row.source}
                      </span>
                    )}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
